import PropTypes from "prop-types";

/**
 *
 * @param {string} className
 * @param {string} fill
 * @param {string} stroke
 * @returns {JSX.Element}
 * @constructor
 */
export default function Tick({ className, fill = 'none', stroke = '#BA191C' }) {
    return (
        <svg className={className} viewBox="0 0 14 14" fill={fill} xmlns="http://www.w3.org/2000/svg">
            <path d="M1 8.64291L4.4338 12.889C4.4338 12.889 8.02497 1 12.58 1" stroke={stroke} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
}

Tick.PropTypes = {
    className: PropTypes.string,
    fill: PropTypes.string,
    stroke: PropTypes.string,
}
